import {
  Box,
  Button,
  Drawer,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import clsx from "clsx";
import React, { useEffect, useState } from "react";

import { gql, useQuery } from "@apollo/client";
import { Add, Clear, FilterList, Print, Search } from "@mui/icons-material";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import emptyList from "../../assets/Image/received.png";
import {
  LIST_BRANCHES_DROPDOWN,
  LIST_CUSTOMERS_DROPDOWN,
  LIST_DELIVERY_AGENTS_DROPDOWN,
} from "../../GlobalsQuery/ListDropdown/ListDropdown";
import { sumArrayOfObjectValue } from "../../helpers/helpersFunction";
import useWidth from "../../Hooks/useWidth";
import CellLink from "../HOC/CustomComponents/CellLink";
import { FixedTableCell } from "../HOC/CustomComponents/FixedTableCell";
import LookupDropdown from "../HOC/CustomComponents/LookupDropdown";
import { Can, SecuredNavLink } from "../HOC/CustomComponents/Secured";
import TableFixedHeaderWraper from "../HOC/CustomComponents/TableWithFixedHeader";
import { lookupCodeIsValid } from "../HOC/CustomFunctions/lookupCodeIsValid";
import { windowUrl } from "../HOC/CustomFunctions/pushUrl";
import { urlParameters } from "../HOC/CustomFunctions/urlParameters";
import FullScreenLoading from "../HOC/FunctionComponents/LoadingPages/FullScreenLoading";
import { CustomAutocomplete } from "../HOC/MUI/CustomAutocomplete";
import MUIDateRangeCustom from "../HOC/MUI/MUIDateRangeCustom";
import MUItextField from "../HOC/MUI/MUItextField";
import MUITablePagination from "../HOC/MUI/TablePagination/MUITablePagination";
import { LIST_PICKUPS } from "./Graphql";
import { PickupStatusColor } from "./PickupStatusColor";
import { dateFormatLL } from "../../helpers/dateFunctions";
import ExportWarehousePickupsList from "./ExportWarehousePickupsList";

const PREFIX = "ListWarehousePickups";

const classes = {
  button: `${PREFIX}-button`,
  btnMargin: `${PREFIX}-btnMargin`,
  mainSearch: `${PREFIX}-mainSearch`,
  titles: `${PREFIX}-titles`,
  toolbar: `${PREFIX}-toolbar`,
  searchForm: `${PREFIX}-searchForm`,
  searchField: `${PREFIX}-searchField`,
  overlay: `${PREFIX}-overlay`,
  searchPadding: `${PREFIX}-searchPadding`,
  drawer: `${PREFIX}-drawer`,
  drawerPaper: `${PREFIX}-drawerPaper`,
  drawerHeader: `${PREFIX}-drawerHeader`,
  content: `${PREFIX}-content`,
  contentShift: `${PREFIX}-contentShift`,
  tableRow: `${PREFIX}-tableRow`,
  shipmentTable_shipmentStatus: `${PREFIX}-shipmentTable_shipmentStatus`,
  shipmentTable_shipmentCode: `shipmentTable_shipmentCode`,
  tablePaper: `${PREFIX}-tablePaper`,
  table_status: `${PREFIX}-table_status`,
  table_code: `${PREFIX}-table_code`,
  toolbarHeader: `${PREFIX}-toolbarHeader`,
  tableBodyRow: `${PREFIX}-tableBodyRow`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled("div")(({ theme }) => ({
  [`& .${classes.button}`]: {
    position: "sticky",
    bottom: 0,
    zIndex: 3,
    backgroundColor: "#fff",
    marginTop: 10,
    padding: 7,
  },

  [`& .${classes.btnMargin}`]: {
    width: "100%",
  },

  [`& .${classes.mainSearch}`]: {
    margin: theme.spacing(0),
    width: "100%",
  },

  [`& .${classes.titles}`]: {
    flex: "1 1 100%",
  },

  [`& .${classes.toolbar}`]: {
    borderBottom: "1px #ccd1d6 solid",
    backgroundColor: "#f5f7f9",
    width: "100%",
    // justifyContent: "space-between",
  },

  [`& .${classes.searchForm}`]: {
    overflowY: "auto",
    width: "100%",
    height: "100%",
    margin: 0,
  },

  [`& .${classes.searchField}`]: {
    padding: theme.spacing(1, 1, 0, 1),
    position: "relative",
    overflow: "hidden",
  },

  [`& .${classes.overlay}`]: {
    width: "100%",
    height: "100%",
    position: "absolute",
    backgroundColor: "#ffffffa8",
    zIndex: 2,
  },

  [`& .${classes.searchPadding}`]: {
    padding: theme.spacing(1),
  },

  //////////////////////Drawer///////////////////

  [`& .${classes.drawer}`]: {
    width: drawerWidth,
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  [`& .${classes.drawerPaper}`]: {
    width: drawerWidth,

    zIndex: "250",

    left: "initial",
    right: "initial",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "100%",
    },
  },

  [`& .${classes.drawerHeader}`]: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },

  [`& .${classes.content}`]: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
  },

  [`& .${classes.contentShift}`]: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: "auto",
    width: "calc(100% - 240px)",
    [theme.breakpoints.down("sm")]: {
      margin: "auto",
      width: "auto",
    },
  },

  [`& .${classes.tableRow}`]: {
    "&:hover": {
      "& .MuiTableCell-root": {
        backgroundColor: "#f5f5f5",
      },
    },
  },

  [`& .${classes.shipmentTable_shipmentStatus}`]: {
    [theme.breakpoints.up("sm")]: {
      zIndex: "100",
      backgroundColor: "#fff",
      position: "sticky",
      top: "0",
      right: "0",
    },
  },

  [`& .${classes.shipmentTable_shipmentCode}`]: {
    [theme.breakpoints.up("sm")]: {
      zIndex: "100",
      backgroundColor: "#fff",
      position: "sticky",
      top: "0",
      left: "0em",
    },
  },

  [`& .${classes.tablePaper}`]: {
    borderRadius: 0,
    width: "100%",
    display: "grid",
  },

  [`& .${classes.table_status}`]: {
    [theme.breakpoints.up("sm")]: {
      zIndex: "100",
      backgroundColor: "#fff",
      position: "sticky",
      top: "0",
      right: "0",
    },
  },

  [`& .${classes.table_code}`]: {
    [theme.breakpoints.up("sm")]: {
      zIndex: "100",
      backgroundColor: "#fff",
      position: "sticky",
      top: "0",
      left: "0",
    },
  },

  [`& .${classes.toolbarHeader}`]: {
    flex: 1,
  },

  [`& .${classes.tableBodyRow}`]: {
    "&:hover": {
      "& .MuiTableCell-root": {
        backgroundColor: "#f5f5f5",
      },
    },
  },
}));

const drawerWidth = 240;

const ListWarehousePickups = (props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const urlQuery = urlParameters(window.location.search);

  const initFromDate = urlQuery["fromDate"]
    ? urlQuery["fromDate"]
    : moment(new Date())
      .locale("en")
      .subtract(1, "month")
      .add(1, "day")
      .format("YYYY-MM-DD");
  const initToDate = urlQuery["toDate"]
    ? urlQuery["toDate"]
    : moment(new Date()).locale("en").format("YYYY-MM-DD");
  const validUrlParameters = Object.keys(urlQuery).length !== 0;

  const [dateRange, setDateRange] = useState([initFromDate, initToDate]);

  const [autocompleteValues, setAutocompleteValues] = useState({
    customer: null,
    deliveryAgent: null,
    branch: null,
  });
  const screenWidth = useWidth();

  const [drawerState, setDrawerState] = React.useState({
    top: true,
    left: screenWidth === "xs" ? false : true,
    bottom: screenWidth === "xs" ? false : true,
    right: screenWidth === "xs" ? false : true,
  });

  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    watch,
    register,
  } = useForm();

  const [rowsPerPage, setRowsPerPage] = useState(urlQuery["rowsPerPage"] ?? 20);
  const initSearch = () => {
    let searchParameters = {
      page: 0,
      refetch: true,
      fromDate: dateRange[0],
      toDate: dateRange[1],
    };

    delete urlQuery["rowsPerPage"];
    if (validUrlParameters) {
      if (urlQuery["code"]) urlQuery["code"] = urlQuery["code"]?.toString();
      searchParameters = urlQuery;
    }
    return {
      ...searchParameters,
    };
  };
  const [search, setSearch] = useState(initSearch());

  useEffect(() => {
    urlQuery["code"] && setValue("code", urlQuery["code"].toString());

    return () => { };
  }, []);

  const history = useHistory();

  const searchParams = (param) => {
    const queryParams = [];
    for (const i in param) {
      encodeURIComponent(param[i]) &&
        queryParams.push(
          encodeURIComponent(i) + "=" + encodeURIComponent(param[i])
        );
    }
    const queryString = queryParams.join("&");
    return queryString;
  };

  const pushUrlSearch = (param) => {
    const params = searchParams(param);

    const url = history.createHref({
      pathname: "/admin/warehouse-pickups",
      search: "?" + params,
    });
    windowUrl(url);
    //this will not effect on history.location.search
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      (event.type === "keydown" || event.type === "submit") &&
      (event.type === "submit" || event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setDrawerState({ ...drawerState, [anchor]: open });
  };
  const filterAnchor = screenWidth === "xs" ? "bottom" : "left";

  const onSubmit = (data) => {
    filterAnchor === "bottom" &&
      setDrawerState((prev) => ({ ...prev, [filterAnchor]: false }));

    let handledData = {
      fromDate: moment(dateRange[0]).locale("en").format("YYYY-MM-DD"),
      toDate: moment(dateRange[1]).locale("en").format("YYYY-MM-DD"),
      branchId: data.branchId,
      statusCode: data.statusCode,
      customerId: data.customerId,
      deliveryAgentId: data.deliveryAgentId,
      page: 0,
    };
    for (const key in handledData) {
      if (
        handledData[key] === undefined ||
        handledData[key] === "" ||
        handledData[key] === null
      ) {
        delete handledData[key];
      }
    }
    if (data.code) {
      handledData = {
        code: data.code.toString(),
        page: 0,
      };
    }
    setSearch((prev) => ({
      ...handledData,
      refetch: !prev.refetch,
    }));
    for (const key in handledData) {
      if (handledData[key] === null) {
        delete handledData[key];
      }
    }
    pushUrlSearch({
      ...handledData,
      rowsPerPage: rowsPerPage,
    });
  };
  const handelAutocompleteDefaultValue = (data, id, fieldName) => {
    const defaultValue = data[Object.keys(data)[0]].find(
      (i) => i.id === parseInt(id)
    );
    defaultValue &&
      setAutocompleteValues((prev) => ({
        ...prev,
        [fieldName]: defaultValue,
      }));
  };
  const parseData = (data) => {
    return data;
  };

  const lookupComplete = (data, name) => {
    const validData = lookupCodeIsValid(data, urlQuery[name]);
    if (validData) {
      setValue(name, urlQuery[name]);
    }
  };

  const handleChangePage = (event, newPage) => {
    pushUrlSearch({
      ...urlQuery,

      page: newPage,
      rowsPerPage: rowsPerPage,
    });

    setSearch((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    pushUrlSearch({
      ...urlQuery,
      page: 0,
      rowsPerPage: +event.target.value,
    });

    setRowsPerPage(+event.target.value);
    setSearch((prev) => ({ ...prev, page: 0 }));
  };
  const { data, loading } = useQuery(
    gql`
      ${LIST_PICKUPS.query}
    `,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache",
      variables: {
        first: rowsPerPage,
        page: search?.page + 1,
        input: {
          ...(search.fromDate && { fromDate: search.fromDate }),
          ...(search.toDate && { toDate: search.toDate }),
          ...(search.statusCode && { statusCode: search.statusCode }),
          ...(search.customerId && { customerId: search.customerId }),
          ...(search.branchId && { branchId: search.branchId }),
          ...(search.code && { code: search.code }),
          ...(search.deliveryAgentId !== "" && {
            deliveryAgentId: search.deliveryAgentId,
          }),
        },
      },
      onCompleted: (data) => { },
    }
  );
  const listWarehousePickups = data?.listWarehousePickups?.data;
  const sumPickups = data?.sumPickups;
  const codeValidation = Boolean(watch("code"));
  const emptyPickupList = listWarehousePickups?.length === 0;

  const onPrint = () => {
    const { page, refetch, ...restParams } = search;
    const params = searchParams(restParams);
    const domain = `${window.location.origin}`;

    window.open(`${domain}/pickup/print?${params}`);
  };
  const exportFilters = {
    ...(search.fromDate && { fromDate: search.fromDate }),
    ...(search.toDate && { toDate: search.toDate }),
    ...(search.statusCode && { statusCode: search.statusCode }),
    ...(search.customerId && { customerId: search.customerId }),
    ...(search.branchId && { branchId: search.branchId }),
    ...(search.code && { code: search.code }),
    ...(search.deliveryAgentId !== "" && {
      deliveryAgentId: search.deliveryAgentId,
    }),
  }

  ////////////////////totalShipmentsCount/////////////////
  return (
    <Root>
      <Drawer
        className={clsx(classes.drawer)}
        variant="persistent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor={filterAnchor}
        open={drawerState[filterAnchor]}
        onClose={() => false}
        dir={theme.direction}
      >
        <div className={classes.drawerHeader} />
        <Toolbar
          variant="dense"
          className={classes.toolbar}
          sx={{ marginBottom: 1 }}
        >
          <Typography
            className={classes.titles}
            color="inherit"
            variant="h6"
            component="div"
          >
            {t("search")}
          </Typography>
          <IconButton
            aria-label="done"
            size="small"
            onClick={toggleDrawer(filterAnchor, false)}
            color={"primary"}
          >
            <Clear />
          </IconButton>
        </Toolbar>

        <Grid
          container
          item
          justifyContent="center"
          alignContent="space-between"
          component={"form"}
          onSubmit={handleSubmit(onSubmit)}
          className={classes.searchForm}
        >
          <Grid
            container
            item
            sm={12}
            justifyContent="flex-start"
            spacing={1}
            className={classes.searchField}
          >
            <Grid container item sm={12} alignItems="flex-start">
              <MUItextField
                label={t("code")}
                name={"code"}
                inputProps={{
                  dir: "ltr",
                }}
                formType={"requireFalse"}
                register={register}
                errors={errors}
                watch={watch("code")}
              />
            </Grid>
            <Grid container item sm={12} alignItems="flex-start">
              <MUIDateRangeCustom
                value={dateRange}
                onChangeValue={(value) => setDateRange(value)}
                disabled={codeValidation}
              />
            </Grid>
            <Can showException permission="shipping.warehouse_pickup.filter_by_branch">
              <Grid container item sm={12} alignItems="flex-start">
                <CustomAutocomplete
                  control={control}
                  errors={errors}
                  name={"branchId"}
                  label={t("branch")}
                  onCompleted={(data) =>
                    handelAutocompleteDefaultValue(
                      data,
                      urlQuery["branchId"],
                      "branch"
                    )
                  }
                  parseData={(data) => parseData(data)}
                  query={LIST_BRANCHES_DROPDOWN.query}
                  defaultValue={autocompleteValues.branch}
                  disabled={codeValidation}
                />
              </Grid>
            </Can>
            <Can
              showException
              permission="shipping.warehouse_pickup.filter_by_delivery_agent"
            >
              <Grid container item sm={12} alignItems="flex-start">
                <CustomAutocomplete
                  name={"deliveryAgentId"}
                  label={t("shippingAgent")}
                  control={control}
                  errors={errors}
                  onCompleted={(data) =>
                    handelAutocompleteDefaultValue(
                      data,
                      urlQuery["deliveryAgentId"],
                      "deliveryAgent"
                    )
                  }
                  parseData={(data) => parseData(data)}
                  query={LIST_DELIVERY_AGENTS_DROPDOWN.query}
                  variables={{
                    input: {
                      active: true,
                    },
                  }}
                  defaultValue={autocompleteValues.deliveryAgent}
                  disabled={codeValidation}
                />
              </Grid>
            </Can>
            <Can showException permission="shipping.warehouse_pickup.filter_by_customer">
              <Grid container item sm={12} alignItems="flex-start">
                <CustomAutocomplete
                  name={"customerId"}
                  label={t("customer")}
                  control={control}
                  errors={errors}
                  onCompleted={(data) =>
                    handelAutocompleteDefaultValue(
                      data,
                      urlQuery["customerId"],
                      "customer"
                    )
                  }
                  parseData={(data) => parseData(data)}
                  query={LIST_CUSTOMERS_DROPDOWN.query}
                  defaultValue={autocompleteValues.customer}
                  disabled={codeValidation}
                />
              </Grid>
            </Can>

            <Grid container item sm={12} alignItems="flex-start">
              <LookupDropdown
                name={"statusCode"}
                label={t("shipmentStatus")}
                control={control}
                errors={errors}
                variables={{ input: { code: "SHP_PICKUP_STATUS" } }}
                onCompleted={(data) => lookupComplete(data, "statusCode")}
                disabled={codeValidation}
              />
            </Grid>
          </Grid>
          <Grid
            container
            item
            sm={12}
            className={clsx(classes.searchPadding, classes.button)}
            alignItems="center"
            alignContent="flex-end"
            justifyContent="flex-end"
          >
            <Button
              className={clsx(classes.btnMargin)}
              variant="contained"
              color="primary"
              type="submit"
              size="large"
              startIcon={<Search />}
              disabled={loading}
            >
              {t("search")}
            </Button>
          </Grid>
        </Grid>
      </Drawer>

      <Grid
        container
        justifyContent="center"
        spacing={3}
        className={clsx(classes.content, classes.mainSearch, {
          [classes.contentShift]: drawerState[filterAnchor],
        })}
      >
        {/* *******Table******* */}

        <Toolbar className={clsx(classes.toolbar)} variant="dense">
          <Typography className={classes.toolbarHeader} variant="h6">
            {t("pickupRequestsList")}
          </Typography>
          <IconButton onClick={toggleDrawer(filterAnchor, true)} size="large">
            <FilterList fontSize="inherit" />
          </IconButton>
          <SecuredNavLink
            permission="shipping.warehouse_pickup.create"
            to={{ pathname: "/admin/warehouse-pickups/create" }}
          >
            <IconButton color={"primary"} size="large">
              <Add fontSize="inherit" />
            </IconButton>
          </SecuredNavLink>
          {/* <Tooltip title="print pickup">
            <Box component="span">
              <IconButton
                aria-label="filter list"
                size="large"
                onClick={onPrint}
                disabled={emptyPickupList}
              >
                <Print />
              </IconButton>
            </Box>
          </Tooltip> */}
          {/* <ExportWarehousePickupsList
            disabled={Boolean(data?.listCollections?.data?.length === 0)}
            filters={exportFilters}
          /> */}
        </Toolbar>

        {loading || emptyPickupList ? (
          <Grid container item justifyContent="center" className={classes.main}>
            {loading ? (
              <FullScreenLoading minHeight={30} />
            ) : (
              <Box textAlign="center">
                <img width="50%" src={emptyList} alt={"delivery box"} />
                <Box
                  component={Typography}
                  variant="h6"
                  color="text.secondary"
                  marginTop="0"
                >
                  {t("searchNoResult")}
                </Box>
              </Box>
            )}
          </Grid>
        ) : (
          <Paper className={classes.tablePaper}>
            <TableFixedHeaderWraper>
              <Table aria-labelledby="tableTitle" aria-label="enhanced table">
                <TableHead>
                  <TableRow>
                    <FixedTableCell className={classes.table_code}>
                      {t("requestCode")}
                    </FixedTableCell>
                    <FixedTableCell>{t("date")}</FixedTableCell>
                    <FixedTableCell>{t("branch")}</FixedTableCell>
                    <FixedTableCell>{t("shippingAgent")}</FixedTableCell>
                    <FixedTableCell>{t("transactionTypeName")}</FixedTableCell>
                    <FixedTableCell>{t("customer")}</FixedTableCell>
                    <FixedTableCell>{t("productsNumber")}</FixedTableCell>
                    {/* <FixedTableCell>{t("pickedShipments")}</FixedTableCell> */}
                    <FixedTableCell>{t("notes")}</FixedTableCell>
                    <FixedTableCell>{t("deliveryAgentNotes")}</FixedTableCell>
                    <FixedTableCell className={classes.table_status}>
                      {t("status")}
                    </FixedTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listWarehousePickups &&
                    listWarehousePickups?.map((row, index) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                          className={classes.tableBodyRow}
                        >
                          <CellLink
                            pathname={`/admin/warehouse-pickups/${row?.id}`}
                            className={classes.table_code}
                          >
                            {row?.code}
                          </CellLink>
                          <FixedTableCell>
                            {dateFormatLL(row?.date)}
                          </FixedTableCell>
                          {row?.branch ? (
                            <CellLink
                              pathname={`/admin/branches/${row?.branch?.id}`}
                            >
                              {row?.branch?.name}
                            </CellLink>
                          ) : (
                            <FixedTableCell> </FixedTableCell>
                          )}
                          {row?.deliveryAgent ? (
                            <CellLink
                              pathname={`/admin/delivery-agents/${row?.deliveryAgent?.id}`}
                            >
                              {row?.deliveryAgent?.name}
                            </CellLink>
                          ) : (
                            <FixedTableCell> </FixedTableCell>
                          )}
                          {row?.transactionType ? (
                            <CellLink
                              pathname={`/admin/shipment-transaction-types/${row?.transactionType?.id}`}
                            >
                              {row?.transactionType?.name}
                            </CellLink>
                          ) : (
                            <FixedTableCell> </FixedTableCell>
                          )}
                          {row?.customer ? (
                            <CellLink
                              pathname={`/admin/customers/${row?.customer?.id}`}
                            >
                              {row?.customer?.name}
                            </CellLink>
                          ) : (
                            <FixedTableCell> </FixedTableCell>
                          )}
                          <FixedTableCell>{row?.productsCount}</FixedTableCell>
                          <FixedTableCell>{row?.notes}</FixedTableCell>
                          <FixedTableCell>
                            {row?.deliveryAgentNotes}
                          </FixedTableCell>
                          <PickupStatusColor
                            code={row.status?.code}
                            className={classes.table_status}
                          >
                            {row.status?.name}
                          </PickupStatusColor>
                        </TableRow>
                      );
                    })}
                  {/* <TableRow>
                    <FixedTableCell colSpan={5}> </FixedTableCell>
                    <FixedTableCell variant="head">{t("total")}</FixedTableCell>
                    <FixedTableCell variant="head">
                      {sumPickups?.shipmentsCount}
                    </FixedTableCell>
                    <FixedTableCell variant="head">
                      {sumPickups?.pickedCount}
                    </FixedTableCell>
                    <FixedTableCell colSpan={2}> </FixedTableCell>
                    <FixedTableCell className={classes.table_status}>
                      {" "}
                    </FixedTableCell>
                  </TableRow> */}
                </TableBody>
              </Table>
            </TableFixedHeaderWraper>
            <MUITablePagination
              count={data?.listWarehousePickups?.paginatorInfo?.total}
              rowsPerPage={rowsPerPage}
              page={!data?.listWarehousePickups ? 0 : search?.page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </Grid>
    </Root>
  );
};

export default ListWarehousePickups;
